module.exports = __webpack_public_path__ + "img/mexico-business-round-2023.917913f4.png";